export default __webpack_public_path__ + "static/media/029-tsunami.97942fc2.svg";